import { organizationDetailsKey } from '../../OrganizationDetails.data';

export const addDetailsSectionKey = organizationDetailsKey.concat(
  '.add-details-section',
);
